import { render } from "./Catalog.vue?vue&type=template&id=136e2ab0&scoped=true"
import script from "./Catalog.vue?vue&type=script&lang=js"
export * from "./Catalog.vue?vue&type=script&lang=js"

import "./Catalog.vue?vue&type=style&index=0&id=136e2ab0&lang=css"
import "./Catalog.vue?vue&type=style&index=1&id=136e2ab0&scoped=true&lang=css"

import exportComponent from "/home/dyam/Documentos/ENSI/mi-stock-ensi-vue/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-136e2ab0"]])

export default __exports__